module.exports = "pegasus/assets/lp/ebook/bg1.png";